export default __webpack_public_path__ + "static/media/Hood of the Putrescent.b4d6af27.jpg";